// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__V_p64","image":"Header_image__3mFt8","name":"Header_name__17CkR","info":"Header_info__1hpnz","infoRow":"Header_infoRow__2UBK4"};